import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getScreenForPath, track } from '../utils/analytics';

const DEDUPE_MS = 300;

function getReferrerHost() {
    if (!document.referrer) {
        return undefined;
    }

    try {
        return new URL(document.referrer).host;
    } catch {
        return undefined;
    }
}

export default function AnalyticsRouteTracker() {
    const location = useLocation();
    const lastTrackedRef = useRef({ path: null, at: 0 });

    useEffect(() => {
        const path = location.pathname;
        const now = Date.now();
        const last = lastTrackedRef.current;

        if (last.path === path && now - last.at < DEDUPE_MS) {
            return;
        }

        lastTrackedRef.current = { path, at: now };

        const metadata = {
            path,
            screen: getScreenForPath(path),
        };

        const referrerHost = getReferrerHost();

        if (referrerHost) {
            metadata.referrer_host = referrerHost;
        }

        track('page_view', metadata);
    }, [location.pathname]);

    return null;
}
